module.exports = __webpack_public_path__ + "img/4.2fdab192.png";